module.exports = __webpack_public_path__ + "img/1F1E7-1F1FB.d3b6be35.svg";